var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.59212V12.4005C2.5 14.1671 2.5 14.1671 4.16667 15.2921L8.75 17.9421C9.44167 18.3421 10.5667 18.3421 11.25 17.9421L15.8333 15.2921C17.5 14.1671 17.5 14.1671 17.5 12.4088V7.59212C17.5 5.83379 17.5 5.83379 15.8333 4.70879L11.25 2.05879C10.5667 1.65879 9.44167 1.65879 8.75 2.05879L4.16667 4.70879C2.5 5.83379 2.5 5.83379 2.5 7.59212Z",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSetting);
export default __webpack_public_path__ + "static/media/Menu-Setting.a6534a7dbbeada85a4dff5b1dc5de7c0.svg";
export { ForwardRef as ReactComponent };